import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { Helper } from "../../../shared/services/Helper.service";
import { NavigationEnd, Router } from "@angular/router";
import { SessionService } from "../../../shared/services/session.service";
import { ISessionState } from "../../../shared/interfaces/isession-state";
import { ConfirmationModal } from "../../../shared/components/dialog/dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { GetBanners } from "../../../states/Root/root.actions";
import { Store } from "@ngrx/store";
import { SelectOption } from "../../../shared/interfaces";
import { StoreService } from "../../../home/services/store.service";
import { EmptyCriteria } from "../../../shared/interfaces/CriteriaModel";
import { CUSTOMER_DO_LOGOUT, DeleteAcount } from 'src/app/states/auth/auth.actions';
import { AlertPopupService } from 'src/app/shared/services/alert-popup.service';
import { Location } from "@angular/common";

@Component({
	selector: 'app-root-container',
	templateUrl: './root-container.component.html',
	styleUrls: ['./root-container.component.scss'],
})
export class RootContainerComponent implements OnInit {
	@ViewChild('sidenav') sidenav;
	public topNavigation: boolean = true;
	public sideNavOpened: boolean = false;
	public displaySearchInput: boolean = true;
	public isUserLoggedIn: boolean;
	public selectOptions: SelectOption[] = [
		{ value: 'Jewellery', label: 'Jewellery' },
		{ value: 'Shop', label: 'Shop' }
	];
	public showSearchPopUp: boolean = false;
	public showSearchBlock: boolean = false;
	public searchCriteria: any = {
		searchText: '',
		searchSelect: this.selectOptions[0].value,
	};
	public isArrowVisible: boolean = false;

	constructor(
		private helper: Helper,
		private router: Router,
		private sessionService: SessionService,
		private dialog: MatDialog,
		private store: Store,
		private storeService: StoreService,
		private alertService: AlertPopupService,
		private location: Location
	) {
		/*
		* Below code is for hiding search input from header when IDP is opened
		* */
		router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				if (event.url.includes('/store') || event.url.includes('/studio') || event.url === '/' || event.url.includes('/collection') && !event.url.includes('collection/')) {
					this.isArrowVisible = false
				} else {
					this.isArrowVisible = true
				}
				if (event.url.includes('item/')) {
					this.displaySearchInput = false;
				} else {
					this.displaySearchInput = true;
				}

				if (this.sidenav) {
					this.sidenav.close();
				}
			}
		});
	}

	ngOnInit(): void {
		const storeData = localStorage.getItem('SELECTED_STORE');
		if (storeData) {
			localStorage.removeItem('SELECTED_STORE');
		}
		this.sessionService.state$.subscribe((state: ISessionState | null) => {
			this.isUserLoggedIn = (state?.token) ? true : false;
		});

		/*
		* Calling get banner API on every page load
		* */
		// this.store.dispatch(
		// 	new GetBanners({
		// 		...EmptyCriteria,
		// 		limit: 25
		// 	})
		// );
	}

	public navigate(key: string, value: string) {
		// this.router.navigate(['items'], { queryParams: { [key]: value } })
		this.router.navigate(['items', value], {
			state:
			{
				[key]: value,
			}
		})
	}

	public doSearch(): void {
		if (!this.searchCriteria.searchText) {
			return;
		}

		setTimeout(() => {
			this.showSearchPopUp = false;
			this.showSearchBlock = false;
		}, 300);

		if (this.searchCriteria.searchSelect === this.selectOptions[0].value) {
			/*if Jewellery option is selected*/
			this.navigate('name', this.searchCriteria.searchText);
		} else {
			/*if shop or other option than product is selected*/
			this.storeService.emitSearchCriteria(this.searchCriteria);
		}

	}

	doLogout() {
		const confirmationModal = this.dialog.open(ConfirmationModal, {
			width: '352px',
			data: {
				dialogTitle: 'Logout',
				dialogMessage: 'Are you sure, you want to logout?',
				dailogCancelBtnTitle: 'CANCEL',
				dailogSuccessBtnTitle: 'OK',
				params: null,
			},
		});

		confirmationModal.componentInstance.onSuccessEvent.subscribe((params) => {
			this.dialog.closeAll();
			this.store.dispatch(
				new CUSTOMER_DO_LOGOUT({})
			)
			this.sessionService.unsetState();
			localStorage.clear()
			sessionStorage.clear()
			this.router.navigate(['/login']);
		});
	}

	deleteAccount() {
		const confirmationModal = this.dialog.open(ConfirmationModal, {
			width: '500px',
			data: {
				dialogTitle: 'Delete Account',
				dialogMessage: "Are you sure you want to delete your account ? </br> This will delete your account permanently and we won't be able to recover your data.",
				dailogCancelBtnTitle: 'CANCEL',
				dailogSuccessBtnTitle: 'OK',
				params: null,
				isInput: true
			},
		});

		confirmationModal.componentInstance.onSuccessEvent.subscribe((params) => {
			const data = localStorage.getItem('state');
			if (data) {
				const jsonData = JSON.parse(data);
				if (jsonData?.profile?.emailId === params) {
					this.store.dispatch(new DeleteAcount(params));
					this.dialog.closeAll();
					this.router.navigate(['/']);
					// this.sessionService.unsetState();
				} else {
					this.alertService.showErrorAlert('Your Email Address Is Invalid');
				}
			}
		});
	}

	backBtnClick() {
		this.location.back();
	}
}
